// STATE: 8% to 20% of the penal amount.  $50 minimum.                                               

// IMMIGRATION: 15% of the penal amount. $100 mimimum. The premium will be chaged and collected  on an annual basis untill the surety is legally dischared form all liability on the bonds(s).

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  let value = null
  let condition = null
  let minimum = null
  if (type === 'STATE') {
    minimum = (bondValue * .08)
    value = (bondValue * .2)
    if (value < 50) {
      value = 50
      minimum = 50
      condition = 'Minimum not met'
    }
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation